import {
  MerchantAccount,
  MerchantAccountArchivePreview,
  MerchantAccountArchiveRequest,
  MerchantAccountFilters,
  MerchantAccountUpdate,
} from "@/types/merchant-account";

import { requestData } from "@/api/api-config";

export async function listMerchantAccounts(
  merchantAccountFilters?: MerchantAccountFilters,
): Promise<MerchantAccount[] | null> {
  return await requestData<MerchantAccount[]>(
    "billing/merchant_accounts",
    "get",
    {
      params: merchantAccountFilters,
    },
  );
}

export async function createMerchantAccount(
  merchantAccount: MerchantAccount,
): Promise<MerchantAccount | null> {
  return await requestData<MerchantAccount>(
    "billing/merchant_accounts",
    "post",
    {
      json: merchantAccount,
    },
  );
}

export async function getMerchantAccount(
  merchantAccountId: string,
): Promise<MerchantAccount | null> {
  return await requestData<MerchantAccount>(
    `billing/merchant_accounts/${merchantAccountId}`,
  );
}

export async function getMerchantAccountArchivePreview(
  merchantAccountId: string,
): Promise<MerchantAccountArchivePreview | null> {
  return await requestData<MerchantAccountArchivePreview>(
    `billing/merchant_accounts/${merchantAccountId}/archive_preview`,
  );
}

export async function archiveMerchantAccount(
  merchantAccountId: string,
  body: MerchantAccountArchiveRequest,
): Promise<boolean | null> {
  return await requestData<boolean>(
    `billing/merchant_accounts/${merchantAccountId}/archive`,
    "put",
    { json: body },
    false,
  );
}

export async function updateMerchantAccount(
  merchantAccountId: string,
  merchantAccount: MerchantAccountUpdate,
): Promise<MerchantAccount | null> {
  return await requestData<MerchantAccount>(
    `billing/merchant_accounts/${merchantAccountId}`,
    "put",
    {
      json: merchantAccount,
    },
  );
}
